import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledCategory = styled.div`
  background-color: #be1717;
  color: white;
  position: absolute;
  bottom: 40px;
  font-size: 12px;
  padding: 5px;
  border-radius: 0 4px 0 4px;
  z-index: 1;
  line-height: normal;

  ${({ theme }) =>
    theme.widgetWidth < 1080 &&
    `bottom: 25px; 
     border-radius: 0 5px 0 5px;
     font-size: .6rem;
     padding: 3px;`}
`;

const CategoryTag = ({ label = "Top games" }) => {
  const { t } = useTranslation();
  return (
    <StyledCategory data-test="styled-category">
      <span data-test="category-tag-label">
        {t("top_games", { defaultValue: label })}
      </span>
    </StyledCategory>
  );
};

export default CategoryTag;
